/* NZ_TIGHT_CARDS_V1 — fuerza precio + add-to-cart juntos en cards */
(function () {
  function findPrice(root) {
    return root.querySelector('.card__information .price, .price');
  }

  function findAddBlock(root) {
    // preferimos mover el FORM real de /cart/add o el product-form
    const form = root.querySelector('.card__information form[action^="/cart/add"]');
    if (form) return form;

    const pf = root.querySelector('.card__information product-form');
    if (pf) return pf;

    // wrappers conocidos tuyos
    const wrap = root.querySelector('.card__information .nz-mini-add-wrap, .card__information .nz-card-add-wrap, .card__information .nz-card-quickadd-form');
    if (wrap) return wrap;

    // fallback: botón de quick-add
    const btn = root.querySelector('.card__information button[name="add"], .card__information .quick-add__submit, .card__information .nz-add-btn');
    return btn || null;
  }

  function applyToCard(card) {
    if (!card || card.dataset.nzTightDone === '1') return;

    const priceEl = findPrice(card);
    const addEl = findAddBlock(card);
    if (!priceEl || !addEl) {
      card.dataset.nzTightDone = '1';
      return;
    }

    // Si el addEl es un botón suelto, intentamos mover su contenedor form/product-form si existe
    let nodeToMove = addEl;
    if (addEl.tagName === 'BUTTON') {
      const f = addEl.closest('form[action^="/cart/add"]');
      if (f) nodeToMove = f;
      const pf = addEl.closest('product-form');
      if (pf) nodeToMove = pf;
    }

    // Reubicar: justo después del precio
    const info = priceEl.closest('.card__information') || card;
    if (nodeToMove && priceEl.parentNode) {
      // evita mover si ya está inmediatamente después
      const next = priceEl.nextElementSibling;
      if (next !== nodeToMove) {
        priceEl.insertAdjacentElement('afterend', nodeToMove);
      }
    }

    card.dataset.nzTightDone = '1';
  }

  function run() {
    document.querySelectorAll('.card-wrapper, .card').forEach(applyToCard);
  }

  // Inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  // Shopify section reloads
  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 50);
  });

  // Observa cambios (filters, infinite scroll, ajax)
  const obs = new MutationObserver(function () {
    // resetea marcado solo en nodos nuevos
    document.querySelectorAll('.card-wrapper[data-nz-tight-done="1"], .card[data-nz-tight-done="1"]').forEach(function (n) {
      // mantenemos el done, no hacemos nada
    });
    setTimeout(run, 30);
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
